module.exports = __webpack_public_path__ + "img/global.bde68ace.svg";